module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-triangle-341e04c9.svg";